import Tracker from 'tracks/tracker';

function postListImpression(eventOption) {
  console.log(eventOption);
  try {
    const { type = 'p' } = eventOption;
    new Tracker()
      .addEvent('post_list_impression', {
        content_type: type
      })
      .send();
  } catch (error) {
    console.error('post_list_impression: ', error);
  }
}

export default postListImpression;
